<template>
    <div class="flex items-center gap-1 pl-3 relative">
        <div class="w-6 h-6 flex justify-center items-center cursor-pointer" @click="store.prevScheduleMonth()">
            <icon width="9" height="13">
                <IconChevronLeft />
            </icon>
        </div>
        <div
            class="rounded bg-grayxlight h-[26px] w-36 text-center pt-1 first-letter:uppercase cursor-pointer select-none"
            @click="openPicker"
        >
            {{ month }}
        </div>
        <div class="w-6 h-6 flex justify-center items-center cursor-pointer" @click="store.nextScheduleMonth()">
            <icon width="9" height="13">
                <IconChevronRight />
            </icon>
        </div>

        <div v-if="isPickerOpen" class="fixed inset-0 z-40" @click="isPickerOpen = false" />

        <div v-if="isPickerOpen" class="absolute top-full mt-1 left-1/2 -translate-x-1/2 z-50 bg-white rounded-xl shadow-lg p-4 w-56">
            <div class="flex items-center justify-between mb-4">
                <div class="w-6 h-6 flex justify-center items-center cursor-pointer" @click="pickerYear--">
                    <icon width="9" height="13">
                        <IconChevronLeft />
                    </icon>
                </div>
                <span class="font-semibold text-darkgray text-sm">{{ pickerYear }}</span>
                <div class="w-6 h-6 flex justify-center items-center cursor-pointer" @click="pickerYear++">
                    <icon width="9" height="13">
                        <IconChevronRight />
                    </icon>
                </div>
            </div>
            <div class="grid grid-cols-3 gap-y-3 text-center">
                <div
                    v-for="(name, index) in MONTHS"
                    :key="index"
                    class="cursor-pointer text-sm py-1 px-1 rounded-full transition-colors"
                    :class="isSelected(index) ? 'bg-grayxlight ' : 'text-graytitle hover:text-darkgray'"
                    @click="selectMonth(index)"
                >
                    {{ name }}
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import IconChevronLeft from '../../ui/icons/IconChevronLeft.vue'
import IconChevronRight from '../../ui/icons/IconChevronRight.vue'
import { useScheduleStore } from '@/stores/scheduleStore'

const store = useScheduleStore()

const MONTHS = ['янв.', 'февр.', 'март', 'апр.', 'май', 'июнь', 'июль', 'авг.', 'сент.', 'окт.', 'нояб.', 'дек.']

const month = computed(() => store.currentScheduleDate.format('MMMM YYYY'))

const isPickerOpen = ref(false)
const pickerYear = ref(store.currentScheduleDate.year())

function openPicker() {
    pickerYear.value = store.currentScheduleDate.year()
    isPickerOpen.value = true
}

function isSelected(monthIndex: number) {
    return store.currentScheduleDate.month() === monthIndex &&
        store.currentScheduleDate.year() === pickerYear.value
}

function selectMonth(monthIndex: number) {
    store.goToMonth(pickerYear.value, monthIndex)
    isPickerOpen.value = false
}
</script>
